<template>
	<BaseModal :title="title" v-model="model" :noPadding="!!$slots.content">
		<div class="-mt-2">
			<div class="px-5">
				<div class="text-label-secondary mb-4 text-center text-sm">
					{{ t('completed', [date.toLocaleString('ru')]) }}
				</div>
				<slot name="content" v-bind="{ close }" />
			</div>
			<BottomActionsModal class="mt-4 pt-4 empty:hidden">
				<slot name="action" v-bind="{ close }" />
			</BottomActionsModal>
		</div>
	</BaseModal>
</template>
<script setup lang="ts">
import BaseModal from '../BaseModal.vue'
import { useI18n } from 'vue-i18n'
import PagePadding from '@/components/PagePadding.vue'
import BottomActionsModal from '@/components/BottomActionsModal.vue'

const { t } = useI18n({
	messages: {
		en: {
			completed: 'Completed on {0}'
		},
		ru: {
			completed: 'Совершена(-о) в {0}'
		}
	}
})

defineProps<{
	title: string
	date: Date
}>()

const model = defineModel<boolean>()

const close = () => {
	model.value = false
}
</script>
